import * as React from 'react';
import { connect } from 'react-redux';

interface ResponseRouteWrapperProps {
  dispatch: any;
  match: {
    params: {
      questionID: string;
    };
  };
  questions: any;
  fillInBlank?: any;
  ResponsesManager: React.ComponentType<any>;
  additionalDatasets?: string[];
}

const ResponseRouteWrapper: React.FC<ResponseRouteWrapperProps> = ({
  dispatch,
  match,
  questions,
  fillInBlank,
  ResponsesManager,
  additionalDatasets = []
}) => {
  const { questionID } = match.params;

  // Find the appropriate dataset (questions or fillInBlank)
  const returnAppropriateDataset = () => {
    let dataset = questions.data?.[questionID];
    let mode = 'questions';

    // Check additional datasets (e.g., fillInBlank)
    additionalDatasets.forEach((datasetName) => {
      if (datasetName === 'fillInBlank' && fillInBlank?.data?.[questionID]) {
        dataset = fillInBlank.data[questionID];
        mode = datasetName;
      }
    });

    return { dataset, mode };
  };

  const { dataset, mode } = returnAppropriateDataset();
  const states = questions?.states || {};

  return (
    <ResponsesManager
      admin
      dispatch={dispatch}
      mode={mode}
      question={dataset}
      questionID={questionID}
      responses={{}}
      states={states}
    />
  );
};

export { ResponseRouteWrapper };
